export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};
